import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import RequireAuth from './RequireAuth';

// render- Dashboard
const ProgramListPage = Loadable(lazy(() => import('pages/ad-tools/ProgramListPage')));
const LaunchpadPage = Loadable(lazy(() => import('pages/ad-tools/LaunchpadPage')));
const CreateAdPage = Loadable(lazy(() => import('pages/ad-tools/createAd/CreateAdPage')));
const FacebookAdsPage = Loadable(lazy(() => import('pages/ad-tools/FacebookAdsPage')));
const TikTokAdsPage = Loadable(lazy(() => import('pages/ad-tools/TikTokAdsPage')));
const SmartAdsPage = Loadable(lazy(() => import('pages/ad-tools/SmartAdsPage')));
const KsAdsPage = Loadable(lazy(() => import('pages/ad-tools/KsAdsPage')));
const MaterialManagerPage = Loadable(lazy(() => import('pages/ad-tools/MaterialManagerPage')));
const CopywritingPage = Loadable(lazy(() => import('pages/ad-tools/CopywritingPage')));
const AdManagerPage = Loadable(lazy(() => import('pages/ad-tools/AdManagerPage')));
const ApplicationStatsPage = Loadable(lazy(() => import('pages/ad-tools/ApplicationStatsPage')));
const MaterialTopPage = Loadable(lazy(() => import('pages/ad-tools/MaterialTopPage')));
const PlayletRecoveryPage = Loadable(lazy(() => import('pages/ad-tools/PlayletRecoveryPage')));
const DesignerRecoveryPage = Loadable(lazy(() => import('pages/ad-tools/DesignerRecoveryPage')));
const OptimizerRecoveryPage = Loadable(lazy(() => import('pages/ad-tools/OptimizerRecoveryPage')));
const AdAccountsPage = Loadable(lazy(() => import('pages/ad-tools/AdAccountsPage')));
const AppGroupsPage = Loadable(lazy(() => import('pages/ad-tools/AppGroupsPage')));
const OrganizationPage = Loadable(lazy(() => import('pages/ad-tools/OrganizationPage')));
const MiniLinkPage = Loadable(lazy(() => import('pages/ad-tools/MiniLinkPage')));
const HomePage = Loadable(lazy(() => import('pages/home')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <RequireAuth>
      <DashboardLayout />
    </RequireAuth>
  ),
  children: [
    {
      path: '/',
      element: <HomePage />
    },
    {
      path: 'programs',
      element: <ProgramListPage />
    },
    {
      path: 'ad-public/launchpad',
      element: <LaunchpadPage />
    },
    {
      path: 'ad-public/create',
      element: <CreateAdPage />
    },
    {
      path: 'ad-public/facebook',
      element: <FacebookAdsPage />
    },
    {
      path: 'ad-public/tiktok',
      element: <TikTokAdsPage />
    },
    {
      path: 'ad-public/smart',
      element: <SmartAdsPage />
    },
    {
      path: 'ad-public/ks',
      element: <KsAdsPage />
    },
    {
      path: 'ad-public/material',
      element: <MaterialManagerPage />
    },
    {
      path: 'ad-public/writing',
      element: <CopywritingPage />
    },
    {
      path: 'ad-insight/ads-manager',
      element: <AdManagerPage />
    },
    {
      path: 'ad-insight/application-stats',
      element: <ApplicationStatsPage />
    },
    {
      path: 'ad-insight/material-top',
      element: <MaterialTopPage />
    },
    {
      path: 'ad-insight/playlet-recovery',
      element: <PlayletRecoveryPage />
    },
    {
      path: 'ad-insight/designer-recovery',
      element: <DesignerRecoveryPage />
    },
    {
      path: 'ad-insight/optimizer-recovery',
      element: <OptimizerRecoveryPage />
    },
    {
      path: 'ad-account/accounts',
      element: <AdAccountsPage />
    },
    {
      path: 'ad-account/application-group',
      element: <AppGroupsPage />
    },
    {
      path: 'account/organization',
      element: <OrganizationPage />
    },
    {
      path: 'mini-link',
      element: <MiniLinkPage />
    }
  ]
};

export default MainRoutes;
